import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";

import { Editor } from "react-draft-wysiwyg";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useForm, useWatch } from "react-hook-form";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

import LoadingModal from "../../components/LoadingModal";

const UPLOAD_IMAGE = gql`
  mutation UploadImage($image: Upload!) {
    uploadImage(image: $image) {
      filename
      mimetype
      encoding
      location
    }
  }
`;

export default function DraftWysiwyg({ onChange, editorState }) {
  const { setValue, getValues, control, watch } = useForm({
    defaultValues: {
      image: null,
    },
  });
  // const image = useWatch({ name: "image", control });
  const [uploadImage, { data, loading: uploadImageLoading }] = useMutation(
    UPLOAD_IMAGE,
    {
      onCompleted({ uploadImage }) {
        setValue("image", uploadImage.location);
      },
    }
  );

  async function _uploadImageCallBack(newImage) {
    if (newImage) {
      await uploadImage({ variables: { image: newImage } });
    }

    // const imageObject = {
    //   file: newImage,
    //   localSrc: URL.createObjectURL(newImage),
    // };

    return new Promise((resolve, reject) => {
      resolve({ data: { link: watch("image") } });
    });
  }

  // const config = {
  //   readonly: false,
  //   height: "450px",
  //   width: "100%",
  //   enableDragAndDropFileToEditor: true,
  //   buttons: [
  //     "fontsize",
  //     "brush",
  //     "|",
  //     "image",
  //     "link",
  //     "|",
  //     "left",
  //     "center",
  //     "right",
  //     "justify",
  //     "|",
  //     "undo",
  //     "redo",
  //     "|",
  //   ],
  //   uploader: {
  //     imagesExtensions: ["jpg", "png", "jpeg", "gif"],
  //     insertImageAsBase64URI: false,
  //     url: "none",
  //     filesVariableName: function (e) {
  //       return "Files";
  //     },

  //     headers: {
  //       Authorization: "bearer token",
  //     },

  //     prepareData: function (data) {
  //       data.append("id", 16);
  //       console.log(data);
  //       return data;
  //     },

  //     isSuccess: function (resp) {
  //       return resp;
  //     },
  //     process: function (resp) {
  //       return {
  //         files: resp.files,
  //         path: resp.path,
  //         baseurl: resp.baseurl,
  //         error: resp.error,
  //         message: resp.message,
  //       };
  //     },

  //     defaultHandlerSuccess: function (data) {
  //       if (data) {
  //         uploadImage({ variables: { image: data } });
  //       }
  //     },
  //   },
  //   image: {
  //     editClass: false,
  //     editStyle: false,
  //     editTitle: false,
  //     editAlt: false,
  //     editMargins: false,
  //     editId: false,
  //   },
  //   language: "zh_tw",
  //   showXPathInStatusbar: false,
  //   showCharsCounter: false,
  //   showWordsCounter: false,
  //   toolbarAdaptive: true,
  //   toolbarSticky: true,
  // };

  return (
    <>
      <LoadingModal loading={uploadImageLoading} />
      <Grid item xs={12} sm={12}>
        {/* <JoditEditor config={config} onChange={onChange} /> */}
        <Editor
          toolbar={{
            options: ["fontSize", "textAlign", "colorPicker", "image", "link"],
            image: {
              uploadCallback: _uploadImageCallBack,
              previewImage: true,
              inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg",
            },
          }}
          editorState={editorState}
          toolbarClassName="toolbar"
          wrapperClassName="wrapper"
          editorClassName="editor"
          editorStyle={{
            border: "1px solid",
            height: "500px",
            width: "100%",
          }}
          localization={{
            locale: "zh_tw",
          }}
          onEditorStateChange={onChange}
        />
      </Grid>
    </>
  );
}
